import { Col, Row, Tabs } from 'antd';
import Title from 'antd/lib/typography/Title';
import { RouteComponentProps } from 'react-router-dom';
import RevenueListContainer from './RevenueListContainer';
import RevenueReportContainer from './RevenueReportContainer';

const { TabPane } = Tabs;

interface ExpenseListMatchParams {
  enterpriseId: string;
}

function RevenueContainer({
  match,
}: RouteComponentProps<ExpenseListMatchParams>) {
  const { enterpriseId } = match.params;

  return (
    <>
      <>
        <Row>
          <Col flex={1}>
            <Title level={3}>매출관리</Title>
          </Col>
        </Row>
        <Tabs destroyInactiveTabPane>
          <TabPane tab="수금현황" key="1">
            <RevenueListContainer enterpriseId={enterpriseId} />
          </TabPane>
          <TabPane tab="통계" key="2">
            <RevenueReportContainer enterpriseId={enterpriseId} />
          </TabPane>
        </Tabs>
      </>
    </>
  );
}

export default RevenueContainer;
